import { UfoIcon } from '@modules/common/components/UfoIcon';
import { Button, Stack, Typography } from '@mui/material';

interface FetchErrorMessageProps {
  onRetry?: () => void;
}

export function FetchErrorMessage({ onRetry }: FetchErrorMessageProps) {
  return (
    <Stack
      direction="column"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      minHeight={350}
    >
      <UfoIcon width={94} />
      <Typography variant="h5">Oops! Something went wrong.</Typography>
      {!!onRetry && (
        <Button
          color="primary"
          size="large"
          variant="outlined"
          onClick={onRetry}
        >
          RETRY
        </Button>
      )}
    </Stack>
  );
}
